import type { QueryClient } from '@tanstack/react-query';

import type { Persona } from '../../../domain/persona';
import type { AppStore } from '../../../services/appStore';
import { translate } from '../../../services/i18n';
import { personaApi } from '../api';
import { PERSONAS_QUERY_KEY } from '../personasQuery/personasQueryKey';

import type { UpdatePersonaRepository } from './useCase';

export const makeUpdatePersonaRepository = (appStore: AppStore, queryClient: QueryClient): UpdatePersonaRepository => ({
  updatePersona: (persona) => personaApi.updatePersona(persona),
  savePersona: (persona) => {
    queryClient.setQueryData(PERSONAS_QUERY_KEY, (oldData: Persona[] | undefined) => {
      if (!oldData) {
        return [persona];
      }

      return oldData.map((p) => (p.id === persona.id ? persona : p));
    });

    appStore.setContactsPersona(persona);
  },
  notifyPersonaUpdated: (persona) => {
    appStore.setSuccessToast({
      content: translate('contacts.persona.updated', { personaName: persona.name }),
    });
  },
});
